module.exports = __webpack_public_path__ + "static/media/LinkedinIcon.17fc84ed.svg";